import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/categories'

export default {
    getCategories(id) {
        return axios.get(`${V1}${RESOURCE_NAME}/treeview?Id=${id}`)
    },

    getCategoriesWithParent(name) {
        return axios.get(`${V1}${RESOURCE_NAME}?ParentName=${name}`);
      },
}
